import React from 'react';
import './AboutSection.css';
import introVideo from '../assets/video/Intro.mp4';
import { FaHeartbeat, FaUserMd, FaClock, FaAward, FaCalendarAlt } from 'react-icons/fa';

function AboutSection() {
    return (
        <section className="about-section">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="about-content">
                            <h1>JDS Hospital – Serving Vizag with Care</h1>
                            <p>Healthcare is personal. At JDS Hospital, we understand that behind every patient is a story, a family, and a hope for healing. Established in 2008 in Visakhapatnam, we've built a legacy rooted in trust, medical excellence, and patient-first care.</p>
                            <p>Our hospital is equipped with modern medical technology and guided by a compassionate team of specialists who treat every patient like their own. Whether it's a routine visit or a health emergency, we're here for you—every hour, every day.</p>
                            <div className="features-grid">
                                <div className="feature-item">
                                    <FaHeartbeat className="feature-icon" />
                                    <span>24/7 Care</span>
                                </div>
                                <div className="feature-item">
                                    <FaUserMd className="feature-icon" />
                                    <span>Expert Doctors</span>
                                </div>
                                <div className="feature-item">
                                    <FaClock className="feature-icon" />
                                    <span>Quick Response</span>
                                </div>
                                <div className="feature-item">
                                    <FaAward className="feature-icon" />
                                    <span>Quality Service</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="about-image">
                            <video autoPlay loop muted className="img-fluid">
                                <source src={introVideo} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div className="image-overlay">
                                <div className="established-on-image">
                                    <FaCalendarAlt className="established-icon" />
                                    <span>Established 2008</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;
